import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";
import { Box, Typography } from "@mui/material";


const formatYAxisLabel = (value) => `${value} min`;



const CustomBarChart = ({ data, highlightedIndex, isMonthly, barSize }) => {

  const CustomTooltip = ({ active, payload, label }) => {
    if ( payload && payload.length) {
      return (
        <Box
          sx={{
            backgroundColor: "white",
            border: "1px solid #d34646",
            borderRadius: "4px",
            padding: "8px",
          }}
        >
          <Typography
            variant="body2"
            sx={{ fontWeight: "bold", color: "#d34646" }}
          >
            {label.day} {label.date}
          </Typography>
          <Typography variant="body2" sx={{ color: "#757575" }}>
            {payload[0].value} min
          </Typography>
        </Box>
      );
    }
    return null;
  };



  return (
    <Box sx={{ width: "100%", height: "485px", position: "relative" }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={{ top: 50, right: 20, left: 20, bottom: 20 }}
        >
          

          <Bar dataKey="value" barSize={barSize} radius={[5, 5, 0, 0]}>
  {data.map((entry, index) => (
    <Cell
      key={`cell-${index}`}
      fill={index === highlightedIndex ? "#d34646" : "#EDF0F7"}
      onMouseEnter={(e) => {
        e.target.setAttribute("fill", "#D34646");
      }}
      onMouseLeave={(e) => {
        e.target.setAttribute("fill", index === highlightedIndex ? "#d34646" : "#EDF0F7");
      }}
      style={{ transition: "fill 0.2s ease-in-out" }}
    />
  ))}
</Bar>





          {/* XAxis */}
          <XAxis
            dataKey="label.day"
            tickLine={false}
            axisLine={{ stroke: "#757575", strokeWidth: 1 }}
            interval={0}
            tick={({ x, y, payload }) => {
              return (
                <g transform={`translate(${x},${y})`}>
                  <text
                    x={0}
                    y={0}
                    dy={5}
                    textAnchor="middle"
                    fill="#757575"
                    fontSize={9}
                  >
                    {data[payload.index].label.day}
                  </text>
                  <text
                    x={0}
                    y={20}
                    dy={0}
                    textAnchor="middle"
                    fill="#000"
                    fontSize={10}
                    fontWeight="bold"
                  >
                    {data[payload.index].label.date}
                  </text>
                </g>
              );
            }}
          />

          {/* YAxis */}
          <YAxis
  domain={[0, 60]} // Always cap at 60 minutes
  tick={{ fill: "#757575", fontSize: 12 }}
  tickFormatter={formatYAxisLabel} // Format in 10-minute steps
  ticks={[0, 10, 20, 30, 40, 50, 60]} // Custom step values
  axisLine={false}
  tickLine={false}
/>


          {/* Tooltip */}
          <Tooltip content={<CustomTooltip />} cursor={{ fill: "none" }} />

        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default CustomBarChart;
